import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

// Shadow cast leftward by the pinned ACTIONS column while the table scrolls
// horizontally, signalling that other columns sit behind it. Layered: a crisp
// seam line plus a deeper diffuse falloff so the overlap reads clearly.
const STICKY_ACTIONS_SHADOW =
  "-1px 0 0 0 rgba(0, 0, 0, 0.12), -12px 0 18px -6px rgba(0, 0, 0, 0.18)";

// Sticky positioning for the ACTIONS column cell so it stays pinned to the
// right edge as the table scrolls horizontally. The shadow only appears while
// the table actually overflows. `zIndex` lets the header cell sit above body
// cells (header 3, body 2). Compose via the sx array form so callers can layer
// their own background and sizing.
export function getStickyActionsCellSx(
  hasHorizontalOverflow: boolean,
  zIndex: number,
): SystemStyleObject<Theme> {
  return {
    position: "sticky",
    right: 0,
    zIndex,
    boxShadow: hasHorizontalOverflow ? STICKY_ACTIONS_SHADOW : "none",
    transition: "box-shadow 0.2s ease",
  };
}
